import { render, staticRenderFns } from "./MaterialListAddNew.vue?vue&type=template&id=28690f48&"
import script from "./MaterialListAddNew.vue?vue&type=script&lang=js&"
export * from "./MaterialListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./MaterialListAddNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports